import type { RoofElevationPlanSettings, RoofPlanSettings } from "building-types/settings/roofPlanSettings";
import { defaultRoofAnnotationSettings } from "doc/settings/defaultSettings";

export type RoofAnnotationSettings = RoofPlanSettings & RoofElevationPlanSettings;

/**
 * Enforces the correct resolution order of settings.
 *
 * @deprecated Remove this when we consolidate the built in plan set with live plans.
 */
export function evalRoofAnnotationSetting(
  settings: RoofAnnotationSettings,
  instanceSettings: RoofAnnotationSettings,
  key: keyof RoofAnnotationSettings,
): boolean {
  return !!(instanceSettings[key] ?? settings[key]);
}

/**
 * Chooses the correct base settings depending on the context.
 *
 * @deprecated Remove this when we consolidate the built in plan set with live plans.
 */
export function getRoofAnnotationSettings(
  builtInRoofAnnotationSettings: RoofAnnotationSettings,
  noSettings?: boolean,
): RoofAnnotationSettings {
  return !noSettings ? builtInRoofAnnotationSettings : defaultRoofAnnotationSettings;
}
